module.exports = __webpack_public_path__ + "static/media/appleIconLight.fde7f5ac.svg";